import React from 'react';
import { HorizontalFillBar } from 'components/Graphs/FillBars';
import EntityItem from 'components/Global/EntityItem/EntityItem.jsx';
import { numberWithCommas, inPercent } from 'helpers/Utils.js';
import ListSync from '@bit/knotchinc.web-react-components.list-sync';
import { SET_INSIGHTS_FILTERS } from 'components/Pages/Entity/actions';
import { TileContentContainer, BoxedFillBarBContainer } from './styled.js';

const BrandItem = ({ data, multiEntity }) => {
  const { name, num_contents, pct_num_contents, public_id, logo_url } = data;

  return (
    <BoxedFillBarBContainer key={public_id}>
      <HorizontalFillBar
        fillPct={inPercent(pct_num_contents)}
        label={<EntityItem data={{ name, public_id, logo_url, type: 'brand' }} />}
        value={numberWithCommas(num_contents)}
        stacked={multiEntity}
        pctWidth={!multiEntity && '60%'}
        labelWidth={!multiEntity && '30%'}
      />
    </BoxedFillBarBContainer>
  );
};

const BrandListTile = (props) => {
  const { store, multiEntity, fetchData } = props;

  return (
    <TileContentContainer>
      <ListSync
        fetch={(clear) => fetchData(clear)}
        listStore={store}
        loadOnScroll
        actionType={SET_INSIGHTS_FILTERS}
      >
        <BrandItem multiEntity={multiEntity} />
      </ListSync>
    </TileContentContainer>
  );
};

export default BrandListTile;
